import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=c634f252&scoped=true"
import script from "./QuoteCard.vue?vue&type=script&lang=js"
export * from "./QuoteCard.vue?vue&type=script&lang=js"
import style0 from "./QuoteCard.vue?vue&type=style&index=0&id=c634f252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c634f252",
  null
  
)

export default component.exports